import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Tengo que saber de acupuntura?',
  answer: 'No, son puntos de presión simples que puedes encontrar con tus propios dedos.'
}, {
  question: '¿Cuánto tiempo tardan los resultados?',
  answer: 'La mayoría siente una pesadez agradable en los párpados en los primeros 5 a 8 minutos.'
}, {
  question: '¿Puedo hacerlo si ya tomo medicación?',
  answer: 'Sí, es un método físico y natural que no interfiere con tratamientos químicos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-navy-800 px-4 py-20" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-15">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-17"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-navy-900 border border-white/10 rounded-lg overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-navy-900/50 transition-colors" data-id="element-20">
                <span className="font-serif text-lg text-white" data-id="element-21">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-22" />
              </button>
              {openIndex === index && <div className="px-6 pb-4" data-id="element-23">
                  <p className="text-gray-300 leading-relaxed" data-id="element-24">{faq.answer}</p>
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}